import { render, staticRenderFns } from "./page-list.vue?vue&type=template&id=753ea92a&scoped=true"
import script from "./page-list.vue?vue&type=script&lang=js"
export * from "./page-list.vue?vue&type=script&lang=js"
import style0 from "./page-list.vue?vue&type=style&index=0&id=753ea92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753ea92a",
  null
  
)

export default component.exports